import { P00039DataRxTxIndex } from '../../P00039Sync';
import { Pool } from '../../../../../../apis/pool.api';
import { IProduct } from '../../../IProduct';
import { getPoolMasterClass } from '../../../../ECoSystemsHelper';

export function P0003603FunctionFinish(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  const master = getPoolMasterClass(pool);
  const presence = master?.hasProduct(pool, productClass) ?? 0;

  editValue(
    P00039DataRxTxIndex.Robot_Installation,
    'rbIConfigurationProduit',
    presence != 0,
    null,
    productClass,
  );
}
